export default __webpack_public_path__ + "static/media/section2-6-img1.5fed3e78.png";